import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const InvestorPortalIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 52 52',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <defs>
      <clipPath id="investor-portal">
        <circle
          cx="26"
          cy="26"
          r="26"
          transform="translate(578.016 -173.526)"
          fill="#eff2f7"
        />
      </clipPath>
    </defs>
    <g transform="translate(-578.016 173.526)">
      <path
        fill="#347ac4"
        d="M624.3-171.118h-8.06v-2.94a4.7,4.7,0,0,0-4.695-4.695H596.725a4.7,4.7,0,0,0-4.69,4.695v2.94h-8.055a1.728,1.728,0,0,0-1.746,1.692v6.576l18.035,4.4a15.928,15.928,0,0,0,7.693,0l18.029-4.4v-6.576A1.677,1.677,0,0,0,624.3-171.118Zm-28.057-2.94a.483.483,0,0,1,.479-.479H611.55a.484.484,0,0,1,.484.479v2.94H596.247Zm7.891,14.157a2.96,2.96,0,0,1-2.944-2.949,2.95,2.95,0,0,1,2.944-2.9,2.952,2.952,0,0,1,2.954,2.9A2.962,2.962,0,0,1,604.138-159.9Z"
        transform="translate(0 15)"
      />
      <g className="c-investor-portal">
        <path
          fill="#347ac4"
          d="M626-174.853v47.673H582.24v-47.673l18.035,4.448a17.2,17.2,0,0,0,7.688,0Z"
          transform="translate(0.019 28.953)"
        />
      </g>
    </g>
  </SvgIcon>
);

export default InvestorPortalIcon;
